import React from "react";
import { useGetQuizzesQuery } from "../../features/quizzes/quizzesApi";
import { sortArrayBasedOnId } from "../../utils/sortArrayBasedOnId";
import Error from "../ui/Error";
import Loading from "../ui/Loading";
import SingleQuiz from "./SingleQuiz";
export default function QuizzesList() {
  const { data: quizzes, isLoading, isError, error } = useGetQuizzesQuery();
  const sortedQuizzes = sortArrayBasedOnId(quizzes);

  // decide what to render in the ui
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error message={error} />;
  } else if (!isLoading && !isError && sortedQuizzes?.length === 0) {
    content = (
      <div style={{ textAlign: "center", fontSize: "18px" }}>
        No quizzes found! Click on the "add quiz" button to add new quizzes.
      </div>
    );
  } else if (!isLoading && !isError && sortedQuizzes?.length > 0) {
    content = (
      <table className="divide-y-1 text-base divide-gray-600 w-full">
        <thead>
          <tr>
            <th className="table-th">Question</th>
            <th className="table-th">Video</th>
            <th className="table-th justify-center">Action</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-600/50">
          {sortedQuizzes?.map((sortedQuiz, i) => (
            <SingleQuiz key={sortedQuiz.id} index={i} quiz={sortedQuiz} />
          ))}
        </tbody>
      </table>
    );
  }

  return <>{content}</>;
}
